import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../context";
import { Modal, Form, Input, Button, Select } from "antd";
import { updateUser } from "../../library/user";
import { FiMail, FiPhone } from "react-icons/fi";
import { FaRegAddressCard } from "react-icons/fa";
import { MdPeopleOutline } from "react-icons/md";
import "./UserInfo.css";
import { AHPUserField } from "./AHPUserField";
import { countryList } from "../../constants/countryList";
import AHPIcon from "../../components/Icons/AHPIcon";
import { districtList } from "../../constants/districtList";
import UserInfoForm from "./UserInfoForm";

function UserInfo(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPortugal, setIsPortugal] = useState(false);
  const info = useContext(AppContext);
  const [form] = Form.useForm();

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const tailLayout = {
    wrapperCol: {
      offset: 4,
      span: 16,
    },
  };

  useEffect(() => {
    if (form && info?.user)
      form.setFieldsValue({
        ...info.user,
      });
    if (info.user?.country === "Portugal") setIsPortugal(true);
  }, [info.user]);

  const submitForm = async () => {
    const data = form.getFieldsValue();
    // add data.district = "" so that it is updated in the db if the country changed from Portugal to a foreign one
    if (!data.district) data.district = "";
    await updateUser(info.user.id, data);
    info.setUser({ ...info.user, ...data });
    setIsModalVisible(false);
  };

  return (
    <div className="ahp-profile">
      <div className="ahp-header">
        <img
          src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/11/logo.png"
          alt="aldeias historicas logo"
        />
      </div>
      <div
        className="ahp-img-background"
        style={{
          backgroundImage:
            "url('https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Idanha-a-Velha-1.jpg'",
        }}
      ></div>
      <div className="ahp-name">{info?.user?.name}</div>
      <AHPUserField
        text={info.t(info?.user?.user_category)}
        icon={<FiMail />}
      />
      <AHPUserField text={info?.user?.email} icon={<FiMail />} />
      <AHPUserField text={info?.user?.phone} icon={<FiPhone />} />
      <AHPUserField text={info?.user?.address} icon={<FaRegAddressCard />} />
      <AHPUserField
        text={info?.user?.postal_code}
        icon={<FaRegAddressCard />}
      />
      <AHPUserField text={info?.user?.district} icon={<FaRegAddressCard />} />
      <AHPUserField text={info?.user?.country} icon={<FaRegAddressCard />} />
      <AHPUserField text={info?.user?.company} icon={<FaRegAddressCard />} />
      <AHPUserField
        text={info?.user?.company_vat}
        icon={<FaRegAddressCard />}
      />
      {info?.user?.roles?.includes("coworker") && (
        <AHPUserField text="Co-worker" icon={<MdPeopleOutline />} />
      )}

      <div className="ahp-user-info">
        {info.t("userSince")} {info?.user?.created_at?.split("T")[0]}
      </div>
      <Button
        onClick={() => setIsModalVisible(true)}
        style={{ marginLeft: -3, marginBottom: "10px" }}
      >
        {info.t("editInfo")}
      </Button>
      <Modal
        title={<AHPIcon children={info.t("editInfo")} />}
        className="ahp-modal"
        visible={isModalVisible}
        footer={null}
        width="auto"
        style={{ maxWidth: "800px" }}
        bodyStyle={{ padding: "0px" }}
      >
        <UserInfoForm
          form={form}
          onFinish={submitForm}
          showPrivacyAndTerms={false}
          actionButtonText={info.t("save")}
          disableUserCategorySelection={true}
          setIsModalVisible={setIsModalVisible}
        />
        {/* <Form form={form} onFinish={submitForm} {...layout}>
          <Form.Item
            name="name"
            label={info.t("name")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="country"
            label={info.t("country")}
            // rules={[
            //   {
            //     required: true,
            //   },
            // ]}
          >
            <Select
              showSearch
              options={countryList.map((c) => ({ value: c, label: c }))}
              onChange={(value) => {
                if (value === "Portugal") setIsPortugal(true);
                else setIsPortugal(false);
                form.setFieldsValue({ district: "" });
              }}
            />
          </Form.Item>
          {isPortugal && (
            <Form.Item
              name="district"
              label={info.t("district")}
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <Select
                showSearch
                options={districtList.map((d) => ({ value: d, label: d }))}
              />
            </Form.Item>
          )}
          <Form.Item
            name="address"
            label={info.t("address")}
            // rules={[
            //   {
            //     required: true,
            //   },
            // ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="phone"
            label={info.t("phone")}
            // rules={[
            //   {
            //     required: true,
            //   },
            // ]}
          >
            <Input />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              {info.t("save")}
            </Button>
            <Button htmlType="button" onClick={() => setIsModalVisible(false)}>
              {info.t("cancel")}
            </Button>
          </Form.Item>
        </Form> */}
      </Modal>
    </div>
  );
}

export default UserInfo;
